import {useCustomer} from '../../../hooks/api/metadata';
import {ObjectId} from 'bson';
import {
  getAgentAnalystField,
  getAgentResearcherField,
  getPrimaryAgentField,
} from '../../../shared/agent';

export function useAgentResearcherField(agentId: ObjectId) {
  const fieldDefinitions = useCustomer().fieldDefinitions ?? [];
  return getAgentResearcherField({fieldDefinitions, agentId});
}

export function useAgentAnalystField(agentId: ObjectId | undefined) {
  const fieldDefinitions = useCustomer().fieldDefinitions ?? [];
  return agentId
    ? getAgentAnalystField({fieldDefinitions, agentId})
    : undefined;
}

export function useAgentFields(agentId: ObjectId) {
  const fieldDefinitions = useCustomer().fieldDefinitions ?? [];

  return {
    researcherField: getAgentResearcherField({fieldDefinitions, agentId}),
    analystField: getAgentAnalystField({fieldDefinitions, agentId}),
    primaryField: getPrimaryAgentField({fieldDefinitions, agentId}),
  };
}
